import { render, staticRenderFns } from "./landing-footer.vue?vue&type=template&id=d21d13b6&scoped=true&"
import script from "./landing-footer.vue?vue&type=script&lang=js&"
export * from "./landing-footer.vue?vue&type=script&lang=js&"
import style0 from "./landing-footer.vue?vue&type=style&index=0&id=d21d13b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21d13b6",
  null
  
)

export default component.exports